import { V4UUID } from '@/firebase/database';
import { Node } from '@/modules/nodesCanvasModule/components/storeClasses/node';
import JSZip from 'jszip';

export abstract class NodeGenStrategy {
  node: Node;
  workspaceId: V4UUID;
  constructor(node: Node, workspaceId: V4UUID) {
    this.node = node;
    this.workspaceId = workspaceId;
  }

  abstract generateCodeZip(zip: JSZip): void;
}
